import {getAlgoliaResults} from '@algolia/autocomplete-js';

export function getBannersPlugin(searchClient) {
    return {
        getSources({query}) {
            return [
                {
                    sourceId: 'bannersPlugin',
                    getItems() {
                        return getAlgoliaResults({
                            searchClient,
                            queries: [
                                {
                                    indexName: ACC.config.algolia.index + '_query_suggestions',
                                    query
                                }
                            ],
                            transformResponse({results}) {
                                let items = [];
                                let userData = results?.[0]?.userData;
                                if (userData !== undefined) {
                                    const banners = userData.filter(data => Boolean(data.banners));
                                    const banner = userData.filter(data => Boolean(data.banner));

                                    if (banners) {
                                        banners.map(function (bannersItem) {
                                            if (bannersItem.banners) {
                                                items = items.concat(bannersItem.banners);
                                            }
                                        });
                                    }
                                    if (banner) {
                                        banner.map(function (bannerItem) {
                                            if (bannerItem.banner) {
                                                items = items.concat(bannerItem.banner);
                                            }
                                        });
                                    }
                                }

                                items.sort((a, b) => a.priority - b.priority);

                                return items.slice(0, ACC.config.algolia.autocompleteBannersMax);
                            }
                        });
                    },
                    templates: {
                        item({item, html}) {
                            let headline = ``;
                            if(item.headline !== undefined && item.headline !== '') {
                                headline = html`<div class="aa-SourceHeader">${item.headline}</div>`;
                            }
                            return html`
                                <div class="aa-banner">
                                    <a href="${item.link}" target="${item.target}" title="${item.headline}">
                                        ${headline}
                                        <div class="aa-banner-image">
                                            <img loading="lazy" src="${item.image}" alt="${item.headline}" title="${item.headline}"/>
                                        </div>
                                    </a>
                                </div>`;
                        },
                        noResults() {
                            return ``;
                        }
                    }
                }
            ];
        }
    };
}